import { SecurityService } from '../services/security.service'
import {
    DoDriverSearchParamsT,
    DoDriverSearchResponse,
    SecurityGetAutoInformationResponseT,
    SecurityGetCheckupStatusParams,
    SecurityGetCheckupStatusResponseT,
    SecurityGetCompanyInformationResponseT,
    SecurityGetPersonInformationResponseT,
    SecurityGetSbHistoryResponse,
    SecurityHistoryItemT,
    SecurityHistoryParamsT,
} from '../types/security.types'

const securityService = new SecurityService()

class SecurityRealisation {
    getPersonInformation(person_iin: string): Promise<SecurityGetPersonInformationResponseT> {
        return securityService.getPersonInformation(person_iin)
    }

    createPersonInformationRequest(person_iin: string): Promise<void> {
        return securityService.createPersonInformationRequest(person_iin)
    }

    getCompanyInformation(company_bin: string): Promise<SecurityGetCompanyInformationResponseT> {
        return securityService.getCompanyInformation(company_bin)
    }

    createCompanyInformationRequest(company_bin: string): Promise<void> {
        return securityService.createCompanyInformationRequest(company_bin)
    }

    getAutoInformation(number: string): Promise<SecurityGetAutoInformationResponseT> {
        return securityService.getAutoInformation(number)
    }

    createAutoInformationRequest(number: string, technical_passport: string): Promise<void> {
        return securityService.createAutoInformationRequest(number, technical_passport)
    }

    setCheckupAccept(identifier: string, type: number, comment: string | null): Promise<void> {
        return securityService.setCheckupAccept(identifier, type, comment)
    }

    setCheckupReject(identifier: string, type: number, comment: string): Promise<void> {
        return securityService.setCheckupReject(identifier, type, comment)
    }

    getCheckupStatus(
        params: SecurityGetCheckupStatusParams
    ): Promise<SecurityGetCheckupStatusResponseT> {
        return securityService.getCheckupStatus(params)
    }

    getSbHistory(params: SecurityHistoryParamsT): Promise<SecurityGetSbHistoryResponse> {
        return securityService.getSbHistory(params)
    }

    doDriverSearch(params: DoDriverSearchParamsT): Promise<DoDriverSearchResponse> {
        return securityService.doDriverSearch(params)
    }
}

export const security = new SecurityRealisation()
